var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "el-image",
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_vm.loading ? _vm._t("placeholder", function () {
    return [_c("div", {
      staticClass: "el-image__placeholder",
      staticStyle: {
        display: "flex",
        "align-items": "center"
      }
    }, [_c("div", {
      staticClass: "el-image__inner",
      class: {
        "el-image__inner--center": _vm.alignCenter,
        "el-image__preview": _vm.preview
      },
      style: {
        backgroundImage: "url(" + _vm.no_img + ")",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "80%",
        backgroundSize: "contain"
      }
    })])];
  }) : _vm.error ? _vm._t("error", function () {
    return [_c("div", {
      staticClass: "el-image__inner",
      class: {
        "el-image__inner--center": _vm.alignCenter,
        "el-image__preview": _vm.preview
      },
      style: {
        backgroundImage: "url(" + _vm.no_img + ")",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "80%",
        backgroundSize: "contain"
      }
    })];
  }) : _c("img", _vm._g(_vm._b({
    staticClass: "el-image__inner",
    class: {
      "el-image__inner--center": _vm.alignCenter,
      "el-image__preview": _vm.preview
    },
    style: _vm.imageStyle,
    attrs: {
      src: _vm.host + _vm.src,
      draggable: "false"
    },
    on: {
      click: _vm.clickHandler
    }
  }, "img", _vm.$attrs, false), _vm.$listeners)), _vm.preview ? [_vm.showViewer ? _c("image-viewer", {
    attrs: {
      "z-index": _vm.zIndex,
      host: _vm.host,
      "initial-index": _vm.imageIndex,
      "on-close": _vm.closeViewer,
      "url-list": _vm.previewSrcList
    }
  }) : _vm._e()] : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };